import { LocalizedString } from '../../../common/localized';
import { CarouselViewModel } from '../carousel/carousel.view-model';
import { ContinueWatchingCarouselViewModel } from '../continue-watching-carousel/continue-watching-carousel.view-model';
import { MarketingDeviceModuleViewModel } from '../device-module/marketing-device-module-view.model';
import { GenericCarouselViewModel } from '../generic-carousel/generic-carousel.view-model';
import { HeroViewModel } from '../hero/hero.view-model';
import { MarketingHeroViewModel } from '../marketing-hero/marketing-hero-view-model';
import { MarketingKidsViewModel } from '../marketing-kids/marketing-kids-view-model';
import { MarketingUspViewModel } from '../marketing-usp/marketing-usp.view-model';
import { MarketingStudioViewModel } from '../marketing-studio/marketing-studio.view-model';
import { MyListCarouselViewModel } from '../my-list-carousel/my-list-carousel.view-model';
import { RecommendationCarouselViewModel } from '../recommendation-carousel/recommendation-carousel.view-model';
import { SeasonBasicCarouselViewModel } from '../season-basic-carousel/season-basic-carousel.view-model';
import { SeasonCollectionCarouselViewModel } from '../season-collection-carousel/season-collection-carousel.view-model';
import { MarketingTrendingViewModel } from '../marketing-trending/marketing-trending.view-model';
import { FaqViewModel } from '../faq/faq-view-model';
import { MarketingCtaViewModel } from '../marketing-cta/marketing-cta.view-model';
import { MarketingEmailCollectorViewModel } from '../marketing-email-collector/marketing-email-collector.view-model';
import { MarketingBannerViewModel } from '../marketing-banner/marketing-banner.view-model';
import { RedeemCtaTrayViewModel } from '../redeem-cta-tray/redeem-cta-tray.view-model';
import { PartnerRedeemViewModel } from '../partner-redeem/partner-redeem.view-model';
import { GenericRedeemViewModel } from '../generic-redeem/generic-redeem.view-model';
import { RedeemUspViewModel } from '../redeem-usp-tray/redeem-usp-tray.view-model';
import { MarketingEmailBlockerViewModel } from '../marketing-email-blocker/marketing-email-blocker.view-model';
import { SpotlightViewModel } from '../spotlight-tray/spotlight-tray.view-model';

export type PageItemViewModel =
  | CarouselViewModel
  | SeasonBasicCarouselViewModel
  | SeasonCollectionCarouselViewModel
  | GenericCarouselViewModel
  | HeroViewModel
  | ContinueWatchingCarouselViewModel
  | MyListCarouselViewModel
  | RecommendationCarouselViewModel
  | MarketingKidsViewModel
  | MarketingUspViewModel
  | MarketingCtaViewModel
  | MarketingStudioViewModel
  | MarketingTrendingViewModel
  | MarketingHeroViewModel
  | MarketingEmailCollectorViewModel
  | MarketingEmailBlockerViewModel
  | MarketingBannerViewModel
  | FaqViewModel
  | RedeemCtaTrayViewModel
  | RedeemUspViewModel
  | PartnerRedeemViewModel
  | GenericRedeemViewModel
  | MarketingDeviceModuleViewModel
  | SpotlightViewModel;

export interface PageScreenViewModel {
  title: LocalizedString;
  pageItems: PageItemViewModel[];
  shouldShowSeoTitle?: boolean;
}

export enum PageItemToDisplayType {
  Simple = 'Simple',
  EmailBlockerContainer = 'EmailBlockerContainer',
}

interface SimplePageItemToDisplay {
  type: PageItemToDisplayType.Simple;
  pageItem: PageItemViewModel;
}

interface EmailBlockerContainerPageItemToDisplay {
  type: PageItemToDisplayType.EmailBlockerContainer;
  items: PageItemViewModel[];
  emailBlockerItem: PageItemViewModel;
  minHeight?: string;
}

export type PageItemViewModelToDisplay = SimplePageItemToDisplay | EmailBlockerContainerPageItemToDisplay;
